import request from '@/utils/request'

// 查询社区活动打卡提交列表
export function listCommunityGroupActivityCheckin(query) {
  return request({
    url: '/biz/admin/community/community/group/activity/checkin/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区活动打卡提交分页
export function pageCommunityGroupActivityCheckin(query) {
  return request({
    url: '/biz/admin/community/community/group/activity/checkin/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区活动打卡提交详细
export function getCommunityGroupActivityCheckin(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/checkin/detail',
    method: 'get',
    params: data
  })
}

// 新增社区活动打卡提交
export function addCommunityGroupActivityCheckin(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/checkin/add',
    method: 'post',
    data: data
  })
}

// 修改社区活动打卡提交
export function updateCommunityGroupActivityCheckin(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/checkin/edit',
    method: 'post',
    data: data
  })
}

// 删除社区活动打卡提交
export function delCommunityGroupActivityCheckin(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/checkin/delete',
    method: 'post',
    data: data
  })
}
